export default __webpack_public_path__ + "static/media/closeWhite.f7ba7895.svg";